var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "table",
      staticClass: "c-table",
      class: {
        "c-table_scrolled": _vm.isScrolled,
        "c-table_scrolled_right":
          !_vm.isScrollEnd && !_vm.data.actions && _vm.isScroll,
        "c-table_scroll_end": _vm.isScrollEnd,
        "c-table_scroll": _vm.isScroll,
      },
    },
    [
      _vm.displayShadow
        ? _c("div", {
            class: {
              "c-table__shadow": _vm.data.actions,
              "c-table__shadow_active": _vm.data.actions,
            },
          })
        : _vm._e(),
      _vm.isScroll
        ? _c("div", { staticClass: "c-table__scrollbar-wrapper" })
        : _vm._e(),
      _c(
        "perfect-scrollbar",
        {
          ref: "wrapper" + (_vm.id !== undefined ? _vm.id : ""),
          staticClass: "c-table__wrapper",
          on: { scroll: _vm.scroll },
        },
        [
          _c(
            "table",
            { ref: "container", staticClass: "c-table__container" },
            [
              _c(
                "thead",
                { ref: "header", staticClass: "c-table__header" },
                _vm._l(_vm.levels, function (i) {
                  return _c(
                    "tr",
                    { key: i, staticClass: "c-table__header-row" },
                    [
                      _vm._l(_vm.getTableColumns(i), function (column) {
                        return _c(
                          "th",
                          {
                            key: column.id,
                            staticClass: "c-table__column",
                            class: {
                              "c-table__column_with_filter": column.type,
                              "c-table__column_hidden": _vm.isDisabled(
                                column.id
                              ),
                              "c-table__column_sorted": _vm.isSorted(column),
                            },
                            style: { width: column.width ? column.width : "" },
                            attrs: {
                              id: `c-table-column-${column.id}`,
                              colspan:
                                column.colspan === undefined
                                  ? _vm.getColspan(column)
                                  : column.colspan,
                              rowspan: _vm.getRowspan(column),
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "c-table__column-wrapper" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "c-table__column-label",
                                    class: {
                                      "c-table__column-label-children":
                                        !_vm.isCategory(column) &&
                                        _vm.sortedColumn &&
                                        !(
                                          _vm.data.type === "discipline" &&
                                          column.id === "explanatory"
                                        ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setSortedColumn(
                                          column,
                                          _vm.sortedColumn
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(column.fullName) + " ")]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      _vm.data.actions && i === 1
                        ? _c(
                            "th",
                            {
                              staticClass:
                                "c-table__column c-table__column_actions",
                              attrs: {
                                id: "c-table-actions-element",
                                rowspan: _vm.levels,
                              },
                            },
                            [
                              _c("div", {
                                staticClass: "c-table__column-empty",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                0
              ),
              _vm._l(_vm.sortedRecords, function (group, groupIndex) {
                return _c(
                  "tbody",
                  { key: groupIndex, staticClass: "c-table__records" },
                  [
                    _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle",
                            value: `category-collapse-${_vm.id}-${groupIndex}`,
                            expression:
                              "`category-collapse-${id}-${groupIndex}`",
                          },
                        ],
                        staticClass: "c-table__record",
                      },
                      [
                        _c(
                          "th",
                          {
                            staticClass: "c-table__cell__collapse__button",
                            style: {
                              "border-bottom":
                                _vm.sortedRecords.length === groupIndex + 1
                                  ? "solid 1px #DFE4EF !important"
                                  : "",
                            },
                            attrs: {
                              colspan:
                                _vm.getTableColumns(_vm.levels).length +
                                (_vm.data.actions ? 1 : 0),
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-table__cell__collapse__button-wrapper",
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass:
                                      "c-table__cell__collapse__button__icon",
                                    attrs: {
                                      width: "22",
                                      height: "22",
                                      viewBox: "0 0 22 22",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("circle", {
                                      attrs: {
                                        cx: "11",
                                        cy: "11",
                                        r: "10.5",
                                        fill: "white",
                                        stroke: "#DFE4EF",
                                      },
                                    }),
                                    _c("path", {
                                      attrs: {
                                        d: "M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z",
                                        fill: "#0066FF",
                                      },
                                    }),
                                    _c("path", {
                                      attrs: {
                                        d: "M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z",
                                        fill: "#0066FF",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "c-table__cell__collapse__button__category__name",
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(group.categoryName) + " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "c-table__cell__collapse__button__category__count",
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(group.records.length) + " "
                                    ),
                                  ]
                                ),
                                group.containsExpiredItem
                                  ? _c("c-button-2", {
                                      directives: [
                                        {
                                          name: "b-popover",
                                          rawName: "v-b-popover.html",
                                          value: {
                                            id: "personalEmployeeDocumentsPopover",
                                            container: "#app",
                                            trigger: "hover click",
                                            content:
                                              "Категория содержит анализы, у которых истек срок годности",
                                            placement: "top",
                                          },
                                          expression:
                                            "{\n                  id: 'personalEmployeeDocumentsPopover',\n                  container: '#app',\n                  trigger: 'hover click',\n                  content: 'Категория содержит анализы, у которых истек срок годности',\n                  placement: 'top',\n                }",
                                          modifiers: { html: true },
                                        },
                                      ],
                                      staticClass:
                                        "c-table__cell__collapse__button__button",
                                      attrs: {
                                        icon: "time-is-out",
                                        size: "iconic",
                                      },
                                    })
                                  : _vm._e(),
                                group.containsExpiringSoonItem
                                  ? _c("c-button-2", {
                                      directives: [
                                        {
                                          name: "b-popover",
                                          rawName: "v-b-popover.html",
                                          value: {
                                            id: "personalEmployeeDocumentsPopover",
                                            container: "#app",
                                            trigger: "hover blur",
                                            content:
                                              "Категория содержит анализы, у которых истекает срок годности",
                                            placement: "top",
                                          },
                                          expression:
                                            "{\n                  id: 'personalEmployeeDocumentsPopover',\n                  container: '#app',\n                  trigger: 'hover blur',\n                  content: 'Категория содержит анализы, у которых истекает срок годности',\n                  placement: 'top',\n                }",
                                          modifiers: { html: true },
                                        },
                                      ],
                                      staticClass:
                                        "c-table__cell__collapse__button__button",
                                      attrs: {
                                        icon: "expiration-date",
                                        size: "iconic",
                                      },
                                    })
                                  : _vm._e(),
                                _c("div", {
                                  staticClass:
                                    "c-table__cell__collapse__button__border__right",
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._l(group.records, function (record, recordIndex) {
                      return _c(
                        "b-collapse",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: record.isShowRow,
                              expression: "record.isShowRow",
                            },
                          ],
                          key: recordIndex,
                          staticClass: "c-table__record",
                          class: {
                            "c-table__record__red": record.expired,
                            "c-table__record__yellow": record.expireSoon,
                          },
                          attrs: {
                            id: `category-collapse-${_vm.id}-${groupIndex}`,
                            tag: "tr",
                            visible: "",
                          },
                        },
                        [
                          record.isShowRow
                            ? [
                                _vm._l(
                                  _vm.getTableColumns(_vm.levels),
                                  function (column) {
                                    return _c(
                                      "td",
                                      {
                                        key: column.id,
                                        staticClass: "c-table__cell",
                                        class: {
                                          "c-table__cell_string":
                                            column.type === "string",
                                          "c-table__cell_reference":
                                            column.type === "reference",
                                          "c-table__cell_number":
                                            column.type === "number",
                                          "c-table__cell_date":
                                            column.type === "date",
                                          "c-table__cell_hidden":
                                            _vm.isDisabled(column.id),
                                          ["c-table__cell_" + column.id]:
                                            column.id,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "c-table__cell-value",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                record[column.id].value
                                              ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(record[column.id].value)
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                _vm.data.actions
                                  ? _c(
                                      "td",
                                      {
                                        staticClass:
                                          "c-table__cell c-table__cell_actions",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-table__cell-actions",
                                          },
                                          [
                                            _c(
                                              "medical-documents-actions-cell",
                                              {
                                                attrs: {
                                                  record: record,
                                                  "record-id": `${groupIndex}-${recordIndex}`,
                                                },
                                                on: {
                                                  resendAnalyse: function (
                                                    $event
                                                  ) {
                                                    return _vm.$emit(
                                                      "resendAnalyse",
                                                      record.analyse_id
                                                    )
                                                  },
                                                  analyseDeleted: function (
                                                    $event
                                                  ) {
                                                    return _vm.$emit(
                                                      "analyseDeleted",
                                                      record.analysisId,
                                                      record.analyse_type.id
                                                    )
                                                  },
                                                },
                                              }
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    }),
                  ],
                  2
                )
              }),
            ],
            2
          ),
        ]
      ),
      _vm.data.records.length > 0
        ? _c(
            "div",
            { ref: "container", staticClass: "c-table__container__mobile" },
            _vm._l(_vm.sortedRecords, function (group, groupIndex) {
              return _c(
                "div",
                { key: groupIndex },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle",
                          value: `category-collapse-${_vm.id}${groupIndex}`,
                          expression: "`category-collapse-${id}${groupIndex}`",
                        },
                      ],
                      staticClass:
                        "c-table__cell__collapse__button d-flex align-items-center shadow-none",
                      class: {
                        "c-table__cell__collapse__button__hide__borders":
                          groupIndex === 0,
                        "c-table__cell__collapse__button__hide__borders__last":
                          _vm.sortedRecords.length === groupIndex + 1,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "c-table__cell__collapse__button-wrapper",
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass:
                                "c-table__cell__collapse__button__icon",
                              attrs: {
                                width: "22",
                                height: "22",
                                viewBox: "0 0 22 22",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("circle", {
                                attrs: {
                                  cx: "11",
                                  cy: "11",
                                  r: "10.5",
                                  fill: "white",
                                  stroke: "#D3D8DF",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  d: "M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z",
                                  fill: "#0066FF",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  d: "M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z",
                                  fill: "#0066FF",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "c-table__cell__collapse__button__category__name",
                            },
                            [_vm._v(_vm._s(group.categoryName))]
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "c-table__cell__collapse__button__category__count",
                            },
                            [_vm._v(" " + _vm._s(group.records.length) + " ")]
                          ),
                          group.containsExpiredItem
                            ? _c("c-button-2", {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle",
                                    value: `category-collapse-${_vm.id}${groupIndex}`,
                                    expression:
                                      "`category-collapse-${id}${groupIndex}`",
                                  },
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.html",
                                    value: {
                                      id: "personalEmployeeDocumentsPopover",
                                      container: "#app",
                                      trigger: "hover blur",
                                      content:
                                        "Категория содержит анализы, у которых истек срок годности",
                                      placement: "top",
                                    },
                                    expression:
                                      "{\n              id: 'personalEmployeeDocumentsPopover',\n              container: '#app',\n              trigger: 'hover blur',\n              content: 'Категория содержит анализы, у которых истек срок годности',\n              placement: 'top',\n            }",
                                    modifiers: { html: true },
                                  },
                                ],
                                staticClass:
                                  "c-table__cell__collapse__button__button",
                                attrs: { icon: "time-is-out", size: "iconic" },
                              })
                            : _vm._e(),
                          group.containsExpiringSoonItem
                            ? _c("c-button-2", {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle",
                                    value: `category-collapse-${_vm.id}${groupIndex}`,
                                    expression:
                                      "`category-collapse-${id}${groupIndex}`",
                                  },
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.html",
                                    value: {
                                      id: "personalEmployeeDocumentsPopover",
                                      container: "#app",
                                      trigger: "hover blur",
                                      content:
                                        "Категория содержит анализы, у которых скоро истечет срок годности",
                                      placement: "top",
                                    },
                                    expression:
                                      "{\n              id: 'personalEmployeeDocumentsPopover',\n              container: '#app',\n              trigger: 'hover blur',\n              content: 'Категория содержит анализы, у которых скоро истечет срок годности',\n              placement: 'top',\n            }",
                                    modifiers: { html: true },
                                  },
                                ],
                                staticClass:
                                  "c-table__cell__collapse__button__button",
                                attrs: {
                                  icon: "expiration-date",
                                  size: "iconic",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "c-table__mobile__collapse",
                      attrs: {
                        id: `category-collapse-${_vm.id}${groupIndex}`,
                        visible: "",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "c-table__container__mobile__fixed__th",
                          attrs: {
                            id: "tableMobileFixed" + _vm.id + groupIndex,
                          },
                        },
                        [
                          _c(
                            "table",
                            { ref: "container", refInFor: true },
                            [
                              _vm._l(
                                _vm.getColumns(_vm.data.levels),
                                function (column, columnIndex) {
                                  return [
                                    _c(
                                      "tr",
                                      {
                                        key: columnIndex,
                                        staticClass: "c-table__record",
                                      },
                                      [
                                        _c(
                                          "th",
                                          {
                                            staticClass:
                                              "c-table__column c-table__column__mobile",
                                            class: {
                                              "c-table__column_sorted":
                                                _vm.isSorted(column),
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__column-wrapper c-table__column-wrapper-mobile",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.setSortedColumn(
                                                      column,
                                                      _vm.sortedColumn
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-table__column-label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(column.label) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._l(
                                          _vm.sortedRecords[groupIndex].records,
                                          function (record, recordIndex) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  key: recordIndex,
                                                  staticClass: "c-table__cell",
                                                  class: {
                                                    "c-table__cell__red":
                                                      record[column.id].expired,
                                                    "c-table__cell__yellow":
                                                      record[column.id]
                                                        .expireSoon,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "c-table__cell-value",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          record[column.id]
                                                            .value
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            record[column.id]
                                                              .value
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                }
                              ),
                              _vm.data.actions
                                ? _c(
                                    "tr",
                                    { staticClass: "c-table__record" },
                                    [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "c-table__column",
                                          attrs: { rowspan: _vm.levels },
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "c-table__column-empty c-table__column-empty-mobile",
                                          }),
                                        ]
                                      ),
                                      _vm._l(
                                        _vm.sortedRecords[groupIndex].records,
                                        function (record, recordIndex) {
                                          return _c(
                                            "td",
                                            {
                                              key: recordIndex,
                                              staticClass: "c-table__cell",
                                            },
                                            [
                                              _c(
                                                "medical-documents-actions-cell",
                                                {
                                                  attrs: {
                                                    record: record,
                                                    "record-id": `hidden-${groupIndex}-${recordIndex}`,
                                                  },
                                                  on: {
                                                    resendAnalyse: function (
                                                      $event
                                                    ) {
                                                      return _vm.$emit(
                                                        "resendAnalyse",
                                                        record.analyse_id
                                                      )
                                                    },
                                                    analyseDeleted: function (
                                                      $event
                                                    ) {
                                                      return _vm.$emit(
                                                        "analyseDeleted"
                                                      )
                                                    },
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                      _c(
                        "perfect-scrollbar",
                        {
                          staticClass:
                            "c-table__container__mobile__scrolled__td",
                          attrs: {
                            id: "tableMobileScroll" + _vm.id + groupIndex,
                            options: {
                              useBothWheelAxes: false,
                              suppressScrollX: false,
                              suppressScrollY: true,
                            },
                            tag: "div",
                          },
                          on: {
                            scroll: function ($event) {
                              return _vm.setShadowTableMobile(
                                _vm.id + groupIndex
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "table",
                            { ref: "container", refInFor: true },
                            [
                              _vm._l(
                                _vm.getColumns(_vm.data.levels),
                                function (column, recordIndex) {
                                  return [
                                    column.colspan === 1
                                      ? _c(
                                          "tr",
                                          {
                                            key: recordIndex,
                                            staticClass: "c-table__record",
                                          },
                                          [
                                            _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "c-table__column c-table__column__mobile",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-table__column-wrapper c-table__column-wrapper-mobile",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__column-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              column.label
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._l(
                                              _vm.sortedRecords[groupIndex]
                                                .records,
                                              function (record, recordIndex) {
                                                return [
                                                  _c(
                                                    "td",
                                                    {
                                                      key: recordIndex,
                                                      staticClass:
                                                        "c-table__cell",
                                                      class: {
                                                        "c-table__cell__red":
                                                          column.id ===
                                                            "analyse_status" &&
                                                          record.expired,
                                                        "c-table__cell__yellow":
                                                          column.id ===
                                                            "analyse_status" &&
                                                          record.expireSoon,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "c-table__cell-value",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              record[column.id]
                                                                .value
                                                            ),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                record[
                                                                  column.id
                                                                ].value
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                  ]
                                }
                              ),
                              _vm.data.actions
                                ? _c(
                                    "tr",
                                    {
                                      staticClass: "c-table__record",
                                      style: {
                                        height:
                                          _vm.data.type === "main-factors"
                                            ? "34px"
                                            : "",
                                      },
                                    },
                                    [
                                      _c(
                                        "th",
                                        { staticClass: "c-table__column" },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "c-table__column-empty c-table__column-empty-mobile",
                                          }),
                                        ]
                                      ),
                                      _vm._l(
                                        _vm.sortedRecords[groupIndex].records,
                                        function (record, recordIndex) {
                                          return _c(
                                            "td",
                                            {
                                              key: recordIndex,
                                              staticClass: "c-table__cell",
                                            },
                                            [
                                              _c(
                                                "medical-documents-actions-cell",
                                                {
                                                  attrs: {
                                                    record: record,
                                                    "record-id": `mobile-${groupIndex}-${recordIndex}`,
                                                  },
                                                  on: {
                                                    resendAnalyse: function (
                                                      $event
                                                    ) {
                                                      return _vm.$emit(
                                                        "resendAnalyse",
                                                        record.analyse_id
                                                      )
                                                    },
                                                    analyseDeleted: function (
                                                      $event
                                                    ) {
                                                      return _vm.$emit(
                                                        "analyseDeleted"
                                                      )
                                                    },
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm.isTableEmpty
        ? _c("div", { staticClass: "c-table__empty__records" }, [
            _vm._v(_vm._s(_vm.emptyRecordsLabel)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }